import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Phone, User, Bus, MapPin } from 'lucide-react';

const DriverCard = ({ driver, isOpen, onClose }) => {
  if (!driver) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Contact Chauffeur</DialogTitle>
          <DialogDescription>Informations de contact pour le trajet en cours</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center space-y-6 py-4">
          {/* Avatar / Photo */}
          <div className="relative">
            <div className="h-24 w-24 rounded-full bg-gray-100 flex items-center justify-center border-4 border-white shadow-lg overflow-hidden">
              {driver.photo ? (
                <img src={driver.photo} alt={driver.name} className="h-full w-full object-cover" />
              ) : (
                <User className="h-12 w-12 text-gray-400" />
              )}
            </div>
            <div
              className={`absolute bottom-0 right-0 h-6 w-6 rounded-full border-2 border-white ${driver.status === 'active' ? 'bg-green-500' : 'bg-gray-400'}`}
            ></div>
          </div>

          {/* Info Chauffeur */}
          <div className="text-center space-y-1">
            <h3 className="text-xl font-bold text-gray-900">{driver.name || 'Chauffeur Inconnu'}</h3>
            <p className="text-sm text-gray-500 flex items-center justify-center gap-1">
              <Bus className="h-3 w-3" /> {driver.busNumber || 'Bus non assigné'}
            </p>
          </div>

          {/* Actions */}
          <div className="w-full space-y-3">
            {driver.phone ? (
              <div className="flex items-center justify-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
                <Phone className="h-4 w-4 text-gray-500" />
                <span className="font-medium text-gray-900 text-lg">{driver.phone}</span>
              </div>
            ) : (
              <div className="flex items-center justify-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200 text-gray-400">
                <Phone className="h-4 w-4" />
                <span>Numéro non disponible</span>
              </div>
            )}

            {driver.lastLocation && (
              <div className="text-xs text-center text-gray-400 flex items-center justify-center gap-1 mt-2">
                <MapPin className="h-3 w-3" />
                Dernière position : {driver.lastLocation}
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DriverCard;
